import functionWrap from 'ming-ui/components/FunctionWrap';
import SaveWorksheetFilter from './SaveWorksheetFilter';

export default SaveWorksheetFilter;
export const saveWorksheetFilter = props => functionWrap(SaveWorksheetFilter, props);
